import axios from "axios";
import { useEffect, useState } from "react";
import { Alert,  Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import api from "../../../../utils/api";
import moment from "moment";
import { RxCross2 } from "react-icons/rx";
import Carousel from "react-multi-carousel";


export const ReferAFriendModal = ({
  show,
  onHide,
  roomId,
  content,
}) => {

  const [referralfname, setReferralfname] = useState([""]);
  const [referrallname, setReferrallname] = useState([""]);
  const [referralemail, setReferralemail] = useState([""]);
  const [referralcontact, setReferralcontact] = useState([""]);
  const [isValid, setIsValid] = useState(true);


  const addRow = () => {
    if (
      referralfname[referralfname.length - 1] &&
      referralcontact[referralcontact.length - 1]
    ) {
      if (referralfname.length < 5) {
        setReferralfname([...referralfname, ""]);
        setReferrallname([...referrallname, ""]);
        setReferralemail([...referralemail, ""]);
        setReferralcontact([...referralcontact, ""]);
        setIsValid(true);
      }
    } else {
      // setIsValid(false);
      Swal.fire({
        title: "Error",
        text: "All fields are required.",
        icon: "error",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      });
      return;
    }
  };

  // Function to delete a row
  const deleteRow = (index) => {
    if (referralfname.length > 1) {
      const newFname = [...referralfname];
      const newLname = [...referrallname];
      const newEmail = [...referralemail];
      const newContact = [...referralcontact];
      newFname.splice(index, 1);
      newLname.splice(index, 1);
      newEmail.splice(index, 1);
      newContact.splice(index, 1);
      setReferralfname(newFname);
      setReferrallname(newLname);
      setReferralemail(newEmail);
      setReferralcontact(newContact);
    }
  };


  const handleInputChange = (index, field, value) => {
    if (field === "contactNumber") {
      // Allow only numbers and max 10 digits
      if (!/^\d{0,10}$/.test(value)) return;

      const updatedContact = [...referralcontact];
      updatedContact[index] = value;
      setReferralcontact(updatedContact);
    } else if (field === "firstName") {
      const updatedFname = [...referralfname];
      updatedFname[index] = value;
      setReferralfname(updatedFname);
    } else if (field === "lastName") {
      const updatedLname = [...referrallname];
      updatedLname[index] = value;
      setReferrallname(updatedLname);
    } else if (field === "email") {
      const updatedEmail = [...referralemail];
      updatedEmail[index] = value;
      setReferralemail(updatedEmail);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const invalidContact = referralcontact.some(
      (contact) => !/^\d{10}$/.test(contact)
    );

    if (
      !referralfname.length ||
      !referralfname[0] ||
      !referralcontact.length ||
      !referralcontact[0] ||
      invalidContact
    ) {
      Swal.fire({
        title: "Error",
        text: invalidContact
          ? "Please enter valid 10-digit mobile numbers."
          : "First name is required.",
        icon: "error",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      });
      return;
    }

    const referralData = {
      client_id: roomId,
      CampaignCode: "CREF_DIA",
      referralfname,
      referrallname,
      referralemail,
      referralcontact,
    };

    try {
      const response = await api.post(
        `advisor/addReferralLead`,
        referralData
      );

      const showAlert = (title, text, icon) =>
        Swal.fire({
          title,
          text,
          icon,
          confirmButtonText: "OK",
          customClass: { confirmButton: "swal-confirm-btn" },
        });

      if (response.data.type === "error") {
        await showAlert("Error", response.data.message, "error");
      } else if (response.data.type === "success") {
        await showAlert("Success", response.data.message, "success");
        setReferralfname([""]);
        setReferrallname([""]);
        setReferralemail([""]);
        setReferralcontact([""]);
      }
    } catch (error) {
      console.error("Error adding referral lead:", error);
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message || "Something went wrong. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
        customClass: { confirmButton: "swal-confirm-btn" },
      });
    }
  };


  const slides = [
    { img: "/assets/images/refer-thumbnail/Bionic-Model.png", link: "https://www.youtube.com/watch?v=QsE99YKNtEk" },
    { img: "/assets/images/refer-thumbnail/No-sales-Target.png", link: "https://www.youtube.com/watch?v=CZTNSHVXGP0" },
    { img: "/assets/images/refer-thumbnail/Client-Story.png", link: "https://www.youtube.com/watch?v=AbaJgoy_9Sg" },
    { img: "/assets/images/refer-thumbnail/Client-Story2.png", link: "https://www.youtube.com/watch?v=beVnN4QFvw0" },
    { img: "/assets/images/refer-thumbnail/Indian-Army.png", link: "https://www.youtube.com/watch?v=4KJ8BsvbzQo" },
    { img: "/assets/images/refer-thumbnail/Merchant-Navy.png", link: "https://www.youtube.com/watch?v=I8qIcE_czAU" },
    { img: "/assets/images/refer-thumbnail/Mis-selling.png", link: "https://www.youtube.com/watch?v=OMEqnHZGWrM" },
    { img: "/assets/images/refer-thumbnail/Goal-based-Investing.png", link: "https://www.youtube.com/watch?v=CHntfq_N6x8&t=2s" },
    { img: "/assets/images/refer-thumbnail/Personalisation.png", link: "https://www.youtube.com/watch?v=KikU__WvFss" },
    { img: "/assets/images/refer-thumbnail/Stop-your-SIP.png", link: "https://www.youtube.com/watch?v=bc5Fhnq_R4U" },
    { img: "/assets/images/refer-thumbnail/Fund-Selection.png", link: "https://www.youtube.com/watch?v=GJna5DzD23A" },
    { img: "/assets/images/refer-thumbnail/SIP-vs-Lumpsum.png", link: "https://www.youtube.com/watch?v=qYlqvH17nyE" },
    { img: "/assets/images/refer-thumbnail/Insurance-vs-investment.png", link: "https://www.youtube.com/watch?v=QD5JwgIZNxc" },

  ];
  return (
    <Modal show={show} size={"xl"} onHide={onHide} dialogClassName="refer-modal" centered aria-labelledby="ReferAFriendModal">

 <Modal.Header closeButton>
    <Modal.Title>Refer a Friend</Modal.Title>
  </Modal.Header>
      <Modal.Body>
        <>
          <div class="container pt-4  mb-5">
            <div class="row pb-3">
              <div class="col-lg-8 col-md-12">
                <h2>Stay connected!</h2>
                <p class="fs-18">
                  Discover our social media content to explore more about our
                  company and our way
                </p>
              </div>
              <div class="col-lg-4  col-md-12 text-lg-end pt-2">
                <span>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/finedge_official/
        "
                  >
                    <img src="/assets/images/instagram-circle.svg" alt="" />
                  </a>
                </span>
                <span>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/finedge-official/?viewAsMember=true
        "
                  >
                    <img src="/assets/images/linkdein-circle.svg" alt="" />
                  </a>
                </span>
                <span>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/FinEdgeOfficial
        "
                  >
                    <img src="/assets/images/facebook-circle.svg" alt="" />
                  </a>
                </span>
              </div>
            </div>
            <div class="home-demo">


              <Carousel
                arrows
                autoPlay
                autoPlaySpeed={2000}
                draggable
                infinite
                keyBoardControl
                swipeable
                showDots={false}
                responsive={{
                  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4, partialVisibilityGutter: 40 },
                  tablet: { breakpoint: { max: 1024, min: 464 }, items: 1, partialVisibilityGutter: 30 },
                  mobile: { breakpoint: { max: 464, min: 0 }, items: 1, partialVisibilityGutter: 30 },
                }}
              >
                {slides.map((item, i) => (
                  <div key={i} className="image-container increase-size mx-1" onClick={() => window.open(item.link, "_blank")}>
                    <img
                      src={item.img}
                      alt="carousel-slide"
                      className="w-full cursor-pointer"
                      style={{ width: "100%" }}
                    />
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
          <div
            className="container-fluid back-clrgreen minht"
            style={{ padding: "110px 0px" }}
          >
            <div className="container position-relative">
              <div className="row">
                <div className="col-md-1 d-block d-md-none text-center mb-5">
                  <img src="/assets/images/Like.svg" alt="" />
                </div>
                <div className="col-md-11 text-center ">
                  <h4 className="fw-normal text-white white-green">
                    Please do let us know if you would like to refer someone you
                    <br /> care about to experience our services.
                  </h4>
                  <p className="fs-18 text-white my-4 white-green">
                    We hope you liked our Dreams into Action Investment platform and
                    we <br /> were able to add tangible value to your financial
                    life!
                  </p>

                  <div className="d-flex flex-column flex-md-row justify-content-center align-items-md-start align-items-center">

                    <div>

                      {referralfname.map((_, index) => (
                        <div
                          key={index}
                          className="d-flex flex-column flex-md-row justify-content-center align-items-center"
                        >
                          <div>
                            <input
                              type="text"
                              name={`firstName-${index}`}
                              placeholder="First Name"
                              className="likebtn ps-3 m-2 white-green"
                              value={referralfname[index]}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "firstName",
                                  e.target.value
                                )
                              }
                            />
                            <input
                              type="text"
                              name={`lastName-${index}`}
                              placeholder="Last Name"
                              className="likebtn ps-3 m-2 my-md-0 my-2 white-green"
                              value={referrallname[index]}
                              onChange={(e) =>
                                handleInputChange(index, "lastName", e.target.value)
                              }
                            />
                            <input
                              type="text"
                              name={`email-${index}`}
                              placeholder="Email"
                              className="likebtn ps-3 m-2 my-md-0 my-2 white-green"
                              value={referralemail[index]}
                              onChange={(e) =>
                                handleInputChange(index, "email", e.target.value)
                              }
                            />
                            <input
                              type="tel"
                              name={`contactNumber-${index}`}
                              placeholder="Contact Number"
                              className="likebtn ps-3 m-2 white-green"
                              value={referralcontact[index]}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "contactNumber",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div>
                            {referralfname.length > 1 && (
                              <RxCross2
                                className="white-green fw-bold fs-3"
                                onClick={() => deleteRow(index)}
                              />
                            )}
                          </div>
                        </div>
                      ))}

                      {/* </div> */}
                    </div>

                    {/* Button section - below inputs in mobile, right side in desktop */}
                    <div className="text-center mt-md-0 ms-md-3">
                      {/* Desktop View */}
                      <span className=" d-md-inline ">
                        <img
                          src="/assets/images/Add.png"
                          alt="Add"
                          className="mt-1"
                          onClick={addRow}
                        />
                      </span>
                    </div>
                  </div>

                  {!isValid && (
                    <p className="alert alert-danger">
                      Please fill all fields before adding a new row
                    </p>
                  )}

                  <button
                    className="btn1 pt-1 mt-2"
                    type="submit"
                    style={{ backgroundColor: "#DDFB99!important" }}
                    onClick={handleSubmit}
                  >
                    <p className="fs-16 mt-2 refer dark-border">
                      Refer a friend{" "}
                      <img
                        src="/assets/images/heart-emoji.svg"
                        alt=""
                        className="ms-2"
                      />
                    </p>
                  </button>
                </div>
                <div className="col-md-1 d-none d-md-block">
                  <img
                    src="/assets/images/Like.svg"
                    alt=""
                    className="float-start"
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
